<template>
  <div>
    <md-tabs @md-changed="uncheckBoxes">
      <!-- Edit -->
      <md-tab md-label="Edit">
        <md-card>
          <md-card-header>
            <h1 class="md-title" style="margin-top: 0">Cras Fermentum Magna</h1>
          </md-card-header>
          <md-card-content :class="{ 'no-padding': fields.length === 0 }">
            <EditingFormField
              v-for="field in fields"
              :key="field.id"
              :field="field"
              :preview="false"
              @delete-field="deleteField"
            ></EditingFormField>
          </md-card-content>
        </md-card>

        <md-card style="margin-top: 20px">
          <md-card-header>
            <div class="md-title">Approval</div>
            <div class="md-subhead">
              Select the group that will approve form submissions
            </div>
          </md-card-header>
          <md-card-content>
            <md-field>
              <label for="group">Group</label>
              <md-select v-model="group" name="group" id="group">
                <md-option value="group-1">Group 1</md-option>
                <md-option value="group-2">Group 2</md-option>
                <md-option value="group-3">Group 3</md-option>
                <md-option value="group-4">Group 4</md-option>
              </md-select>
            </md-field>
          </md-card-content>
        </md-card>
      </md-tab>
      <!-- Preview -->
      <md-tab md-label="Preview">
        <md-card>
          <md-card-header>
            <h1 class="md-title" style="margin-top: 0">Cras Fermentum Magna</h1>
          </md-card-header>
          <md-card-content :class="{ 'no-padding': fields.length === 0 }">
            <EditingFormField
              v-for="field in fields"
              :key="field.id"
              :field="field"
              :preview="true"
            ></EditingFormField>
          </md-card-content>
          <md-card-actions>
            <md-button class="md-primary md-raised" disabled>Submit</md-button>
          </md-card-actions>
        </md-card>
      </md-tab>
    </md-tabs>

    <md-speed-dial class="md-bottom-center">
      <md-speed-dial-target>
        <md-icon>add</md-icon>
      </md-speed-dial-target>

      <md-speed-dial-content>
        <md-button class="md-icon-button" @click="addField('text')">
          <md-icon>text_fields</md-icon>
        </md-button>

        <md-button class="md-icon-button" @click="addField('choice')">
          <md-icon>check_box</md-icon>
        </md-button>

        <md-button class="md-icon-button" @click="addField('table')">
          <md-icon>table_chart</md-icon>
        </md-button>
      </md-speed-dial-content>
    </md-speed-dial>
  </div>
</template>

<script>
import EditingFormField from "./EditingFormField.vue";

export default {
  name: "FormBuilder",
  data: () => ({
    fields: [],
    layout: [],
    group: "group-1",
  }),
  components: {
    EditingFormField,
  },
  methods: {
    addField(fieldType) {
      let field = { id: this.fields.length };

      switch (fieldType) {
        case "text":
          field.type = "text";
          field.answerLength = "short";
          field.question = "Question";
          break;

        case "choice":
          field.type = "choice";
          field.question = "Question";
          field.options = [
            { id: 1, label: "Option 1", value: false },
            { id: 2, label: "Option 2", value: false },
            { id: 3, label: "Option 3", value: false },
          ];
          break;

        case "table":
          break;
      }

      this.fields.push(field);
    },
    deleteField(id) {
      let i = this.fields.findIndex((field) => field.id === id);

      this.fields.splice(i, 1);
    },
    uncheckBoxes() {
      this.fields.forEach((field) => {
        if (field.type === "choice") {
          field.options.forEach((option) => {
            option.value = false;
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.no-padding {
  padding: 0;
}

.md-tab {
  padding-left: 0;
  padding-right: 0;
}
</style>